import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';
import ServiceTypesSection from '../home/components/ServiceTypesSection';

export default function ReparationFenetreVilleurbanne() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/33745883392?text=Bonjour,%20je%20souhaite%20un%20diagnostic%20vidéo%20pour%20ma%20fenêtre%20à%20Villeurbanne', '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section with City Name */}
      <CityHero cityName="Villeurbanne" />

      {/* Service Types Section - Moved here */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {/* PVC Section */}
          <div className="grid md:grid-cols-2 gap-12 items-center mb-24">
            <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/0aad6cdc2ec1b7a2e0b3baa917b48146.jpg"
                alt="Réparation fenêtre PVC"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold mb-6 text-gray-900">
                Réparation Fenêtres PVC
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Spécialistes de la réparation de fenêtres PVC à Villeurbanne. Nous intervenons rapidement pour tous vos problèmes : vitrage cassé, mécanismes défaillants, joints usés ou problèmes d'étanchéité.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-teal-500 flex-shrink-0"></i>
                  <span className="text-gray-700">Remplacement de vitrage simple et double</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-teal-500 flex-shrink-0"></i>
                  <span className="text-gray-700">Réparation des mécanismes d'ouverture</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-teal-500 flex-shrink-0"></i>
                  <span className="text-gray-700">Changement de joints d'étanchéité</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-teal-500 flex-shrink-0"></i>
                  <span className="text-gray-700">Ajustement et réglage des ouvrants</span>
                </li>
              </ul>
              <a
                href="/reparation-fenetre-pvc-lyon"
                className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
              >
                En savoir plus
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          {/* Bois Section */}
          <div className="grid md:grid-cols-2 gap-12 items-center mb-24">
            <div className="order-2 md:order-1">
              <h2 className="text-4xl font-bold mb-6 text-gray-900">
                Réparation Fenêtres Bois
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Experts en restauration de fenêtres bois anciennes et modernes. Nous préservons le charme authentique de vos menuiseries tout en améliorant leurs performances thermiques et acoustiques.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-amber-500 flex-shrink-0"></i>
                  <span className="text-gray-700">Traitement du bois contre l'humidité</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-amber-500 flex-shrink-0"></i>
                  <span className="text-gray-700">Réparation des parties endommagées</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-amber-500 flex-shrink-0"></i>
                  <span className="text-gray-700">Restauration complète des menuiseries</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-amber-500 flex-shrink-0"></i>
                  <span className="text-gray-700">Finitions et peintures professionnelles</span>
                </li>
              </ul>
              <a
                href="/reparation-fenetre-bois-lyon"
                className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
              >
                En savoir plus
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl order-1 md:order-2">
              <img
                src="https://readdy.ai/api/search-image?query=Traditional%20wooden%20window%20frame%20craftsmanship%20detail%20showing%20natural%20wood%20grain%20texture%20quality%20carpentry%20work%20classic%20design%20residential%20architecture%20warm%20tones%20simple%20clean%20background&width=800&height=600&seq=wood-window-service-villeurbanne-001&orientation=landscape"
                alt="Réparation fenêtre bois"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Aluminium Section */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=Contemporary%20aluminum%20window%20frame%20modern%20architecture%20sleek%20metal%20finish%20minimalist%20design%20large%20glass%20panels%20urban%20residential%20building%20clean%20lines%20neutral%20background%20professional%20quality&width=800&height=600&seq=alu-window-service-villeurbanne-001&orientation=landscape"
                alt="Réparation fenêtre aluminium"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold mb-6 text-gray-900">
                Réparation Fenêtres Aluminium
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Spécialistes des menuiseries aluminium modernes. Intervention sur tous types de fenêtres et baies vitrées coulissantes avec garantie de qualité et respect des normes en vigueur.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-gray-600 flex-shrink-0"></i>
                  <span className="text-gray-700">Réparation de baies vitrées coulissantes</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-gray-600 flex-shrink-0"></i>
                  <span className="text-gray-700">Remplacement des galets et rails</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-gray-600 flex-shrink-0"></i>
                  <span className="text-gray-700">Traitement anti-oxydation</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-gray-600 flex-shrink-0"></i>
                  <span className="text-gray-700">Rénovation complète des châssis</span>
                </li>
              </ul>
              <a
                href="/reparation-fenetre-alu-lyon"
                className="inline-flex items-center gap-2 bg-gray-700 hover:bg-gray-800 text-white px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
              >
                En savoir plus
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section - 2 Columns */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Nos Services de Réparation à Villeurbanne
            </h2>
            <p className="text-xl text-gray-600">
              Spécialistes de tous types de fenêtres
            </p>
          </div>

          <div className="space-y-16">
            {/* Service 1 - PVC - Image à gauche */}
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20white%20PVC%20window%20with%20double%20glazing%20in%20contemporary%20home%20interior%2C%20clean%20simple%20background%20highlighting%20window%20frame%20details%2C%20professional%20window%20repair%20service%2C%20high%20quality%20PVC%20window%20mechanism%20visible%2C%20bright%20natural%20lighting&width=600&height=400&seq=pvc-window-villeurbanne-001&orientation=landscape"
                  alt="Réparation fenêtre PVC Villeurbanne"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="space-y-6">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center">
                  <i className="ri-window-line text-3xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">Réparation Fenêtres PVC</h3>
                <p className="text-gray-600 text-lg">
                  Réparation complète de vos fenêtres PVC à Villeurbanne : mécanismes défectueux, joints usés, vitrage cassé, problèmes d'étanchéité. Intervention rapide dans tous les quartiers.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-500 text-xl mt-1"></i>
                    <span className="text-gray-700">Remplacement de mécanismes et poignées</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-500 text-xl mt-1"></i>
                    <span className="text-gray-700">Changement de joints d'étanchéité</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-500 text-xl mt-1"></i>
                    <span className="text-gray-700">Réparation de vitrage endommagé</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-500 text-xl mt-1"></i>
                    <span className="text-gray-700">Ajustement et réglage complet</span>
                  </li>
                </ul>
                <Link
                  to="/reparation-fenetre-pvc-lyon"
                  className="inline-flex items-center bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  En savoir plus <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>

            {/* Service 2 - Bois - Image à droite */}
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div className="space-y-6 lg:order-1">
                <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center">
                  <i className="ri-window-2-line text-3xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">Réparation Fenêtres Bois</h3>
                <p className="text-gray-600 text-lg">
                  Restauration et réparation de fenêtres en bois à Villeurbanne. Traitement du bois, remplacement de vitrage, rénovation complète. Idéal pour les immeubles anciens du centre-ville.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-amber-500 text-xl mt-1"></i>
                    <span className="text-gray-700">Traitement et protection du bois</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-amber-500 text-xl mt-1"></i>
                    <span className="text-gray-700">Réparation de cadres et ouvrants</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-amber-500 text-xl mt-1"></i>
                    <span className="text-gray-700">Restauration de fenêtres anciennes</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-amber-500 text-xl mt-1"></i>
                    <span className="text-gray-700">Finitions et peinture</span>
                  </li>
                </ul>
                <Link
                  to="/reparation-fenetre-bois-lyon"
                  className="inline-flex items-center bg-amber-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-amber-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  En savoir plus <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
              <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl lg:order-2">
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20wooden%20window%20frame%20in%20classic%20architecture%2C%20natural%20wood%20grain%20texture%20visible%2C%20traditional%20craftsmanship%20details%2C%20warm%20wood%20tones%2C%20simple%20clean%20background%20highlighting%20window%20restoration%20work%2C%20professional%20carpentry%20quality&width=600&height=400&seq=wood-window-villeurbanne-001&orientation=landscape"
                  alt="Réparation fenêtre bois Villeurbanne"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>

            {/* Service 3 - Aluminium - Image à gauche */}
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=sleek%20modern%20aluminum%20window%20frame%20with%20large%20glass%20panels%2C%20contemporary%20minimalist%20design%2C%20silver%20grey%20aluminum%20finish%2C%20clean%20lines%20and%20modern%20architecture%2C%20simple%20background%20emphasizing%20window%20structure%2C%20professional%20installation%20quality&width=600&height=400&seq=alu-window-villeurbanne-001&orientation=landscape"
                  alt="Réparation fenêtre aluminium Villeurbanne"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="space-y-6">
                <div className="w-16 h-16 bg-gradient-to-br from-gray-500 to-gray-600 rounded-xl flex items-center justify-center">
                  <i className="ri-layout-line text-3xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900">Réparation Fenêtres Aluminium</h3>
                <p className="text-gray-600 text-lg">
                  Spécialiste de la réparation de fenêtres aluminium à Villeurbanne. Remplacement de mécanismes, joints, vitrage. Intervention sur tous types de fenêtres alu modernes.
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-gray-600 text-xl mt-1"></i>
                    <span className="text-gray-700">Réparation de baies coulissantes</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-gray-600 text-xl mt-1"></i>
                    <span className="text-gray-700">Remplacement de galets et rails</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-gray-600 text-xl mt-1"></i>
                    <span className="text-gray-700">Traitement anti-oxydation</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-gray-600 text-xl mt-1"></i>
                    <span className="text-gray-700">Réglage de châssis</span>
                  </li>
                </ul>
                <Link
                  to="/reparation-fenetre-alu-lyon"
                  className="inline-flex items-center bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  En savoir plus <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof Section - 2 Columns */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Ils Nous Font Confiance à Villeurbanne
            </h2>
            <p className="text-xl text-gray-600">
              Plus de 500 clients satisfaits dans toute la ville
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Testimonial 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                  SL
                </div>
                <div>
                  <div className="font-bold text-gray-900">Sophie L.</div>
                  <div className="text-sm text-gray-600">Gratte-Ciel, Villeurbanne</div>
                  <div className="flex gap-1 mt-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Intervention très rapide pour réparer ma fenêtre PVC qui ne fermait plus. Le technicien est arrivé dans l'heure et a résolu le problème en 30 minutes. Service impeccable aux Gratte-Ciel !"
              </p>
              <div className="mt-4 text-sm text-gray-500">Il y a 3 jours</div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                  MD
                </div>
                <div>
                  <div className="font-bold text-gray-900">Marc D.</div>
                  <div className="text-sm text-gray-600">Charpennes, Villeurbanne</div>
                  <div className="flex gap-1 mt-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Excellent service pour la réparation de mes volets roulants. Le diagnostic vidéo par WhatsApp m'a permis d'avoir un devis immédiat. Réparation effectuée le jour même. Je recommande vivement !"
              </p>
              <div className="mt-4 text-sm text-gray-500">Il y a 1 semaine</div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                  CB
                </div>
                <div>
                  <div className="font-bold text-gray-900">Catherine B.</div>
                  <div className="text-sm text-gray-600">Cusset, Villeurbanne</div>
                  <div className="flex gap-1 mt-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Réparation de ma baie vitrée coulissante qui coinçait. Travail soigné, tarif honnête et technicien très professionnel. Parfait pour une intervention à Cusset !"
              </p>
              <div className="mt-4 text-sm text-gray-500">Il y a 2 semaines</div>
            </div>

            {/* Testimonial 4 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                  JM
                </div>
                <div>
                  <div className="font-bold text-gray-900">Jean-Michel P.</div>
                  <div className="text-sm text-gray-600">Tonkin, Villeurbanne</div>
                  <div className="flex gap-1 mt-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Fenêtres en bois de mon appartement ancien réparées avec soin. Le technicien a pris le temps de bien faire les choses. Résultat impeccable et garantie de 2 ans. Merci !"
              </p>
              <div className="mt-4 text-sm text-gray-500">Il y a 3 semaines</div>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="text-4xl font-bold text-teal-600 mb-2">500+</div>
              <div className="text-gray-600">Clients à Villeurbanne</div>
            </div>
            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="text-4xl font-bold text-teal-600 mb-2">98%</div>
              <div className="text-gray-600">Satisfaction</div>
            </div>
            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="text-4xl font-bold text-teal-600 mb-2">&lt;2h</div>
              <div className="text-gray-600">Délai d'intervention</div>
            </div>
            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <div className="text-4xl font-bold text-teal-600 mb-2">2 ans</div>
              <div className="text-gray-600">Garantie</div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Diagnostic Section - 2 Columns */}
      <section className="py-20 bg-gradient-to-br from-teal-50 via-white to-orange-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-green-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                <i className="ri-whatsapp-line text-lg"></i>
                <span>Service Exclusif Villeurbanne</span>
              </div>

              <div className="space-y-4">
                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
                  Diagnostic Vidéo
                  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-green-500 to-teal-500 mt-2">
                    Gratuit par WhatsApp
                  </span>
                </h2>
                <p className="text-xl text-gray-600">
                  Obtenez un diagnostic instantané et un devis estimatif en 15 minutes pour votre fenêtre à Villeurbanne. Service disponible 7j/7.
                </p>
              </div>

              {/* Benefits */}
              <div className="space-y-4">
                <div className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex-shrink-0">
                    <i className="ri-time-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">Réponse en 15 minutes</h3>
                    <p className="text-gray-600 text-sm">Notre expert à Villeurbanne vous répond rapidement</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg flex-shrink-0">
                    <i className="ri-smartphone-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">Simple et rapide</h3>
                    <p className="text-gray-600 text-sm">Filmez, envoyez, recevez votre diagnostic</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex-shrink-0">
                    <i className="ri-money-euro-circle-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">Devis gratuit immédiat</h3>
                    <p className="text-gray-600 text-sm">Estimation tarifaire avant déplacement</p>
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <button
                onClick={handleWhatsAppClick}
                className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-3xl"></i>
                <span>Démarrer le diagnostic</span>
                <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
              </button>

              {/* Instructions */}
              <div className="bg-gradient-to-r from-green-500/10 to-teal-500/10 border-l-4 border-green-500 p-4 rounded-lg">
                <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <i className="ri-information-line text-green-500"></i>
                  Comment ça marche ?
                </h4>
                <ol className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-start gap-2">
                    <span className="font-bold text-green-500">1.</span>
                    <span>Cliquez sur le bouton WhatsApp</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-bold text-green-500">2.</span>
                    <span>Filmez votre fenêtre ou volet</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-bold text-green-500">3.</span>
                    <span>Envoyez la vidéo à notre expert</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-bold text-green-500">4.</span>
                    <span>Recevez diagnostic et devis en 15 min</span>
                  </li>
                </ol>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20window%20repair%20technician%20using%20smartphone%20for%20video%20diagnostic%20consultation%20with%20customer%2C%20modern%20WhatsApp%20video%20call%20interface%20visible%20on%20phone%20screen%2C%20expert%20analyzing%20window%20mechanism%20remotely%2C%20professional%20mobile%20diagnostic%20service%2C%20clear%20view%20of%20video%20consultation%20process%20for%20window%20repair&width=400&height=500&seq=whatsapp-villeurbanne-diag-001&orientation=portrait"
                  alt="Diagnostic vidéo WhatsApp Villeurbanne"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>

              {/* Floating Badge */}
              <div className="absolute -top-4 -right-4 bg-white rounded-2xl shadow-xl p-4">
                <div className="flex items-center gap-3">
                  <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-green-500 to-green-600 rounded-xl">
                    <i className="ri-whatsapp-line text-3xl text-white"></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">Disponible</div>
                    <div className="text-sm text-gray-600">7j/7</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEO Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Réparation de Fenêtres à Villeurbanne : Votre Expert Local
            </h2>
            
            <p className="text-gray-700 mb-6">
              Située dans la métropole de Lyon, <strong>Villeurbanne</strong> (69100) est la deuxième ville du département du Rhône avec plus de 150 000 habitants. Nos équipes interviennent dans tous les quartiers de Villeurbanne pour la <strong>réparation de fenêtres</strong>, <strong>baies vitrées</strong> et <strong>volets roulants</strong> : Gratte-Ciel, Charpennes, Cusset, Tonkin, Flachet, Croix-Luizet, Buers, Perralière, Saint-Jean, Maisons-Neuves.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Pourquoi Choisir Notre Service à Villeurbanne ?
            </h3>
            
            <p className="text-gray-700 mb-6">
              Spécialistes de la <strong>réparation de fenêtres à Villeurbanne</strong>, nous intervenons rapidement pour tous vos problèmes de menuiserie : fenêtre bloquée, vitrage cassé, mécanisme défectueux, joint usé, volet roulant en panne. Notre connaissance approfondie de Villeurbanne et de son parc immobilier (immeubles anciens du centre, résidences modernes, maisons individuelles) nous permet d'adapter nos interventions à chaque situation.
            </p>

            <div className="bg-teal-50 border-l-4 border-teal-500 p-6 rounded-lg mb-8">
              <h4 className="text-xl font-bold text-gray-900 mb-3">
                Zones d'Intervention à Villeurbanne
              </h4>
              <ul className="grid md:grid-cols-2 gap-2 text-gray-700">
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-teal-500"></i>
                  <span>Gratte-Ciel (69100)</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-teal-500"></i>
                  <span>Charpennes (69100)</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-teal-500"></i>
                  <span>Cusset (69100)</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-teal-500"></i>
                  <span>Tonkin (69100)</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-teal-500"></i>
                  <span>Flachet (69100)</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-teal-500"></i>
                  <span>Croix-Luizet (69100)</span>
                </li>
              </ul>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Nos Tarifs de Réparation à Villeurbanne
            </h3>
            
            <p className="text-gray-700 mb-6">
              Nous proposons des <strong>tarifs transparents et compétitifs</strong> pour la réparation de fenêtres à Villeurbanne. Diagnostic gratuit, devis détaillé, intervention rapide. Consultez notre <Link to="/blog/prix-reparation-fenetre-lyon-2025" className="text-teal-600 hover:text-teal-700 underline font-medium">guide des prix 2025</Link> pour plus d'informations sur nos tarifs.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Questions Fréquentes sur la Réparation de Fenêtres à Villeurbanne
            </h3>
            
            <div className="space-y-4">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="font-bold text-gray-900 mb-2">Quel est le délai d'intervention à Villeurbanne ?</h4>
                <p className="text-gray-700">
                  Nous intervenons en moins de 2 heures dans tous les quartiers de Villeurbanne pour les urgences. Pour les interventions planifiées, nous proposons des rendez-vous sous 24 à 48h.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="font-bold text-gray-900 mb-2">Intervenez-vous dans tous les quartiers de Villeurbanne ?</h4>
                <p className="text-gray-700">
                  Oui, nous couvrons l'ensemble de Villeurbanne : Gratte-Ciel, Charpennes, Cusset, Tonkin, Flachet, Croix-Luizet, Buers, Perralière, Saint-Jean, Maisons-Neuves et tous les autres quartiers.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="font-bold text-gray-900 mb-2">Proposez-vous une garantie sur vos réparations ?</h4>
                <p className="text-gray-700">
                  Toutes nos réparations sont garanties 2 ans pièces et main-d'œuvre. Nous utilisons uniquement des pièces de qualité professionnelle pour assurer la durabilité de nos interventions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Demandez Votre Devis Gratuit à Villeurbanne
            </h2>
            <p className="text-xl text-gray-600">
              Réponse personnalisée sous 24h
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <a href="tel:0980803684" className="flex flex-col items-center p-6 bg-teal-50 rounded-xl hover:bg-teal-100 transition-all cursor-pointer">
                <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-phone-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">Téléphone</h3>
                <p className="text-teal-600 font-medium">09 80 80 36 84</p>
              </a>

              <button
                onClick={handleWhatsAppClick}
                className="flex flex-col items-center p-6 bg-green-50 rounded-xl hover:bg-green-100 transition-all cursor-pointer"
              >
                <div className="w-14 h-14 bg-green-600 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-whatsapp-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">WhatsApp</h3>
                <p className="text-green-600 font-medium">Diagnostic Vidéo</p>
              </button>

              <a href="mailto:info@fenetreslyon.fr" className="flex flex-col items-center p-6 bg-orange-50 rounded-xl hover:bg-orange-100 transition-all cursor-pointer">
                <div className="w-14 h-14 bg-orange-600 rounded-full flex items-center justify-center mb-3">
                  <i className="ri-mail-line text-2xl text-white"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                <p className="text-orange-600 font-medium">info@fenetreslyon.fr</p>
              </a>
            </div>

            <div className="text-center">
              <Link
                to="/"
                className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Retour à l'accueil
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
